// vue components  列表数据字段名对应 Remark
const layout = import('@/layout/index.vue'); //外层框架
const home = import('@/views/Home-new.vue'); //主页
const layoutMain = import('@/views/layoutMain.vue')

// 一体化视图
const userinfo = import('@/views/user/userInfo.vue');  //个人信息
const changepassword = import('@/views/user/changePassword.vue');  //修改密码

const systemsetting = import('@/views/systemSetting/system.vue');  //应用设置
const rightsetting = import('@/views/systemSetting/right.vue');  //权限设置
const rolesetting = import('@/views/systemSetting/role.vue');  //角色设置
const menusetting = import('@/views/systemSetting/menu.vue');  //菜单设置
const sysapisetting = import('@/views/systemSetting/sysapi.vue');  //webapi设置
const syslog = import('@/views/systemSetting/log.vue');  //日志管理

const hospitalsetting = import('@/views/hospitalSetting/hospital.vue');  //医院设置
const departmentsetting = import('@/views/hospitalSetting/dept.vue');  //部门设置
const groupsetting = import('@/views/hospitalSetting/group.vue');  //小组设置
const meetingsetting = import('@/views/hospitalSetting/meeting.vue');  //会场设置
const usersetting = import('@/views/hospitalSetting/user.vue');  //用户设置
const patientsetting = import('@/views/hospitalSetting/patient.vue');  //病人设置
const roleTableNew = import('@/views/hospitalSetting/roleTableNew.vue');  //用户权限设置

const dictionarysetting = import('@/views/templateSetting/dictionary.vue');  //数据字典设置
const templatesetting = import('@/views/templateSetting/remoteTemplate.vue');  //模板设置
const dictionarycomp = import('@/views/templateSetting/dictionaryComp.vue');  //模板设置-数据字典配置模板
const qcfactorandpfsetting = import('@/views/templateSetting/qcfactorandpf.vue');  //质控因子设置

const recognitionMatch = import('@/views/hospitalSetting/recognitionMatch.vue');//检查互认项目匹配
const inspectionMatch = import('@/views/hospitalSetting/inspectionMatch.vue');//检验互认项目匹配
const indexWeightSetting = import('@/views/systemSetting/indexWeightSetting.vue')//主索引权重设置
const primaryIndex = import('@/views/systemSetting/primaryIndex.vue')//主索引权重设置
const suspectedMain = import('@/views/systemSetting/SuspectedMain/index.vue')//疑似主索引

const recognitionWater = import('@/views/hospitalSetting/recognitionWater.vue') // 检验互认对码流水
const inspectionWater = import('@/views/hospitalSetting/inspectionWater.vue') // 检查互认对码流水
function look(n) {
  switch (n) {
    case 'home':
      return home;
    case 'layout':
      return layout;
    case 'userinfo':
      return userinfo
    case 'changepassword':
      return changepassword
    case 'systemsetting':
      return systemsetting
    case 'hospitalsetting':
      return hospitalsetting
    case 'rightsetting':
      return rightsetting
    case 'rolesetting':
      return rolesetting
    case 'menusetting':
      return menusetting
    case 'usersetting':
      return usersetting
    case 'groupsetting':
      return groupsetting
    case 'meetingsetting':
      return meetingsetting
    case 'departmentsetting':
      return departmentsetting
    case 'sysapisetting':
      return sysapisetting
    case 'syslog':
      return syslog
    case 'patientsetting':
      return patientsetting
    case 'qcfactorandpfsetting':
      return qcfactorandpfsetting
    case 'dictionarysetting':
      return dictionarysetting
    case 'templatesetting':
      return templatesetting
    case 'dictionarycomp':
      return dictionarycomp
    case 'recognitionmatch':
        return recognitionMatch
    case 'inspectionmatch':
        return inspectionMatch
    case 'inspectionwater':
        return inspectionWater
    case 'recognitionwater':
        return recognitionWater
    case 'indexweightsetting':
        return indexWeightSetting;
    case 'layoutmain':
        return layoutMain;
    case 'primaryindex':
        return primaryIndex;
    case 'roletablenew':
        return roleTableNew;
    case 'suspectedmain':
        return suspectedMain;
    default:
      return home;
  }
}

export default (name) => () => look(name);



// WEBPACK FOOTER //
// ./src/utils/lazyLoading.js